// Generated types for ActionInputParameter
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ActionParameterReadAPI, ActionParameterWriteAPI } from './actionparameter';
import { ActionParameterReadAPISchemaObject, ActionParameterWriteAPISchemaObject } from './actionparameter';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ActionInputParameterReadAPI extends ActionParameterReadAPI {
}

export interface ActionInputParameterWriteAPI extends ActionParameterWriteAPI {
  item?: string;
  bound_to?: string[];
  /** The Action this input parameter belongs to. */
  owner_action?: string;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ActionInputParameterReadAPISchema: z.ZodType<ActionInputParameterReadAPI> = ActionParameterReadAPISchemaObject.extend({}).passthrough();

export const ActionInputParameterWriteAPISchema: z.ZodType<ActionInputParameterWriteAPI> = ActionParameterWriteAPISchemaObject.extend({
  item: z.string().optional(),
  bound_to: z.array(z.string()).optional(),
  owner_action: z.string().optional(),
}).passthrough();
